import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackLink({ to = "/", label = "Back to home" }) {
  return (
    <Link
      to={to}
      aria-label={label}
      className="group inline-flex items-center gap-2 rounded-md text-sm font-medium text-neutral-600 transition-colors duration-200 hover:text-neutral-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-black/30 dark:text-neutral-400 dark:hover:text-white dark:focus-visible:ring-white/40"
    >
      <ArrowLeft
        size={16}
        className="transition-transform duration-200 group-hover:-translate-x-0.5"
      />
      <span>{label}</span>
    </Link>
  );
}
